import {ETransactionStatusName, ETransactionType} from '../../@types/payrix';
import type {ProcessorPaymentMeta} from '../../@types/payments';

export interface PaymentEmailKind {
    isVoid: boolean;
    isRefund: boolean;
}

/**
 * Classify a parsed transaction for the purpose of choosing the client-facing
 * payment email subject and body in PaymentActionBox._sendEmails.
 *
 * IMPORTANT: a Payrix void does NOT create a CreditCardReverseAuth transaction.
 * The server void endpoint (POST /payrix/payments/void/:transactionId), on an
 * open batch, simply nulls the batch on the ORIGINAL sale txn — its `type` stays
 * CreditCardSale/ECheckSale. parsePaymentMeta surfaces that as
 * `statusText === Voided` (see Payrix.parsePaymentMeta), which is also how the
 * LawPay-normalized path and the on-screen status banner detect a void.
 *
 * The original code keyed `isVoid` off `type === CreditCardReverseAuth`, a
 * LawPay-era condition that never matches a real Payrix void. As a result voids
 * fell through to the default "Thank you for your payment!" template and emailed
 * clients a payment receipt for a voided charge. (OWA-508)
 */
export function classifyPaymentForEmail(meta: Pick<ProcessorPaymentMeta, 'type' | 'statusText'>): PaymentEmailKind {
    const isVoid = meta.statusText === ETransactionStatusName.Voided;
    const isRefund = [ETransactionType.ECheckRefund, ETransactionType.CreditCardRefund].includes(meta.type);
    return {isVoid, isRefund};
}
